import { capitalizeString } from 'lib/helpers'
import * as Constants from './constants'
// Remove Excess Whitespace
// ' Abstract   Art From United States    For Sale  ' => 'Abstract Art From United States For Sale'
export const stringCleanup = (value: string): string => value.replace(/^\s+|\s+$|\s+(?=\s)/g, '')
export const prettyCategory = (category: string | null | undefined): string => {
  if (!category) {
    return 'Art'
  }

  return category
    .replace(/^Mixed Media$/i, 'Mixed Media Art')
    .replace(/^Printmaking$/i, 'Art Prints')
    .replace(/^Digital$/i, 'Digital Art')
    .replace(/^Installation$/i, 'Art Installations')
    .replace(/^all$/i, 'Art')
}
export const getFirstFacetValue = (facetName: string, facetValues: Array<string>): string => {
  const [facetValue] = facetValues || [] // Get First Item/Value

  if (facetName === 'category') {
    return facetValue || 'All'
  }

  return facetValue || ''
}

export const getFirstThreeArtists = (results: Array<any>): Array<string> => {
  if (!results || !results.length) {
    return []
  }

  const artists = []

  for (let i = 0; i < 3; i++) {
    if (results[i]) {
      const name = `${results[i].firstName ? results[i].firstName : ''} ${
        results[i].lastName ? results[i].lastName : ''
      }`
      artists.push(name)
    }
  }

  return artists
}
export default { ...Constants, stringCleanup, prettyCategory, capitalizeString, getFirstFacetValue }